// Creative Flare Yorkshire C.I.C. — content

import hero1 from "../assets/img/hero_1.jpeg";
import hero2 from "../assets/img/hero_2.jpeg";
import hero3 from "../assets/img/hero_3.jpeg";
import hero4 from "../assets/img/hero_4.jpeg";
import beck from "../assets/img/services/beck.jpeg";
import edu1 from "../assets/img/services/edu_1.jpeg";
import edu2 from "../assets/img/services/edu_2.jpeg";
import edu3 from "../assets/img/services/edu_3.jpeg";
import cafe1 from "../assets/img/services/cafe_1.jpeg";
import cafe2 from "../assets/img/services/cafe_2.jpeg";
import cafe3 from "../assets/img/services/cafe_3.jpeg";
import sip1 from "../assets/img/services/sip_1.jpeg";
import sip2 from "../assets/img/services/sip_2.jpeg";
import sip3 from "../assets/img/services/sip_3.jpeg";
import sip4 from "../assets/img/services/sip_4.jpeg";
import well1 from "../assets/img/services/well_1.jpeg";
import well2 from "../assets/img/services/well_2.jpeg";
import well3 from "../assets/img/services/well_3.jpeg";
import well4 from "../assets/img/services/well_4.jpeg";
import oth1 from "../assets/img/services/oth_1.jpeg";
import oth2 from "../assets/img/services/oth_2.jpeg";
import oth3 from "../assets/img/services/oth_3.jpeg";
import oth4 from "../assets/img/services/oth_4.jpeg";
import oth5 from "../assets/img/services/oth_5.jpeg";
import vid1 from "../assets/img/services/vids/vid_1.mp4";
import vid2 from "../assets/img/services/vids/vid_2.mp4";
import ladies from "../assets/img/ladies.jpeg";
import galleryCook from "../assets/img/gallery/cook.png";
import galleryBooks from "../assets/img/gallery/books.png";
import galleryArt from "../assets/img/gallery/art.png";

export const ORG = {
  name: "Creative Flare Yorkshire",
  entity: "C.I.C.",
  fullName: "Creative Flare Yorkshire C.I.C.",
  companyNumber: "9308373",
  registeredAddress: {
    line1: "10 Chaffinch Road",
    line2: "Bradford BD8 0RF",
  },
  venue: {
    name: "Lower Grange Community Centre",
    label: "Community Venue",
  },
  email: "creativeflarebradford@yahoo.co.uk",
  press: "creativeflarebradford@yahoo.co.uk",
  phones: [
    { display: "07856 504478", tel: "+447856504478" },
    { display: "07743 643314", tel: "+447743643314" },
  ],
  socials: [
    { name: "Instagram", url: "https://www.instagram.com/creative_flare1" },
    { name: "Facebook", url: "https://www.facebook.com/creativeflarebradford" },
    { name: "TikTok", url: "https://www.tiktok.com/@creativeflare" },
    { name: "YouTube", url: "https://www.youtube.com/@creativeflarebradford" },
  ],
};

export const NAV = [
  { label: "Who We Are", to: "/" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "Services & Programmes", to: "/services" },
  { label: "Contact", to: "/contact" },
];

// Curated warm, community-focused imagery
export const HERO_COLLAGE = [hero1, hero2, hero3, hero4,
  "https://images.unsplash.com/photo-1543269865-cbf427effbad?crop=entropy&cs=srgb&fm=jpg&w=900&q=85", // group workshop
  "https://images.unsplash.com/photo-1529390079861-591de354faf5?crop=entropy&cs=srgb&fm=jpg&w=900&q=85", // family activity
  "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&w=900&q=85", // creative hands
  "https://images.unsplash.com/photo-1526976668912-1a811878dd37?crop=entropy&cs=srgb&fm=jpg&w=900&q=85", // diverse community
]

export const HOME_STATS = [
  { value: "500", label: "People Supported", suffix: "+" },
  { value: "40", label: "Workshops Delivered", suffix: "+" },
  { value: "12", label: "Community Partners", suffix: "" },
  { value: "8", label: "Programmes Live", suffix: "" },
];

export const FOCUS_AREAS = [
  {
    title: "Community engagement",
    text: "Bringing neighbours together through inclusive, welcoming gatherings that build local pride and belonging.",
    image: "https://images.unsplash.com/photo-1526976668912-1a811878dd37?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    title: "Creative activities",
    text: "",
    bullets: ["Art sessions", "Sip and paints", "General creativity"],
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    title: "Wellbeing & inclusion",
    text: "Safe, accessible spaces that support mental health, confidence, and social connection.",
    image: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    title: "Skills development",
    text: "Our community cafe a place to experience real life work experience..",
    image: ladies,
  },
];

export const EVENTS = [
  {
    id: "evt-beauty-2026-09",
    title: "Beauty course",
    date: "2026-09-30",
    text: "Join us this September for a beauty course covering practical skills and confidence in a welcoming community setting.",
  },
  {
    id: "evt-cooking-2026-12",
    title: "Cooking course",
    date: "2026-12-14",
    text: "A hands-on cooking course on 14 December — learn, share, and take new skills home.",
  },
];

export const GALLERY_IMAGES = [
  {
    id: "gal-cook",
    src: galleryCook,
    caption: "Hands-on cooking in the community kitchen.",
  },
  {
    id: "gal-books",
    src: galleryBooks,
    caption: "Preparing activity packs for families and young people.",
  },
  {
    id: "gal-art",
    src: galleryArt,
    caption: "Creative sessions — colour, glitter, and care.",
  },
];

export const SERVICES = [
  {
    title: "Beck Adventures",
    text: "Beck Adventures is an exciting outdoor learning workshop that combines physical activity, creativity, wellbeing and environmental education. Through fun and engaging sessions, children and their families are encouraged to explore nature, build confidence and develop important life skills. In the Beautiful pitty Beck.",
    image: beck,
    images: [beck],
    accent: "primary",
  },
  {
    title: "Education and Training",
    text: "Creative Flare delivers education and training courses such as Beauty Therapy, massage therapy , personal development, wellbeing, and employability support. Our courses help participants build confidence, gain industry skills, and prepare for employment, self-employment, or further training.",
    image: edu1,
    images: [edu1, edu2, edu3],
    accent: "black",
  },
  {
    title: "Community cafe",
    text: `The Community Café is more than a place to eat—it is a place to belong. Every Tuesday from 9:30am to 10:30am, people from across the community come together to enjoy a healthy, affordable breakfast, make friends, share cultures and experiences, and break the cycle of loneliness and isolation. It is a safe, welcoming space where everyone can feel valued, connected and at home.

The café is also a training hub for women and young people, providing valuable work experience, practical skills and confidence to support their journey towards employment, education or volunteering.`,
    image: cafe1,
    images: [cafe1, cafe2, cafe3],
    accent: "primary",
  },
  {
    title: "Sip and Paints",
    text: "A community Sip & Paint is a fun, relaxed and inclusive creative session where people can come together to paint, socialise and connect in a welcoming, enviroment . Participants can enjoy our refreshing mocktails , express their creativity, meet new people and take a break from everyday pressures. It is a great way to build confidence, reduce isolation, celebrate creativity and bring the community together—no painting experience needed.",
    image: sip1,
    images: [sip1, sip2, sip3, sip4],
    accent: "black",
  },
  {
    title: "Well-Being and mental health",
    text: `Creative Flare delivers a variety of creative wellbeing workshops and community projects designed to improve mental wellbeing, reduce isolation and challenge social norms and local issues through art, creativity and education.

With over 15 years of experience in group work and training in art therapy, we create safe, supportive spaces where people can express themselves, build confidence, connect with others and improve their overall wellbeing. Our sessions use creativity as a powerful tool for healing, connection, learning and positive change.`,
    image: well1,
    images: [well1, well2, well3, well4],
    accent: "primary",
  },
  {
    title: "Other Services",
    text: "We deliver a wide range of unique and inclusive projects that bring people together, celebrate diversity and promote wellbeing. Our activities include:",
    bullets: [
      "Make Me a Rag Doll – exploring race, identity, culture and belonging",
      "HAF holiday programmes for children and young people",
      "Roller-skating clubs",
      "Urdu language classes",
      "Cooking projects",
      "Community celebrations for occasions such as Black History Month, Eid and Christmas and silent discos",
    ],
    image: oth1,
    images: [oth1, oth2, oth3, oth4, oth5],
    accent: "black",
  },
];

export const YOUTUBE_CHANNEL = "https://www.youtube.com/@creativeflarebradford";

export const PROJECT_VIDEOS = [
  {
    id: "vid-1",
    src: vid1,
    title: "Community in action",
    caption: "A look at recent Creative Flare sessions and the people at the heart of our work.",
    showOnHome: true,
    showOnServices: true,
  },
  {
    id: "vid-2",
    src: vid2,
    title: "Past project highlights",
    caption: "Moments from workshops, celebrations and community projects across Bradford.",
    showOnHome: false,
    showOnServices: true,
  },
];

export const PROGRAMMES_COPY = {
  headline: "Programmes for every age.",
  body: "We provide programmes that encourage learning, confidence, creativity, and community participation for people of all ages — from young people finding their voice to older adults staying connected.",
  pillars: [
    { label: "Learning", text: "Curiosity-led sessions that meet people where they are." },
    // { label: "Confidence", text: "Every session designed to leave you feeling a little taller." },
    { label: "Creativity", text: "Art, making, expression — the language everyone speaks." },
    { label: "Community", text: "Real people, real neighbourhoods, real belonging." },
  ],
};
